import { render, staticRenderFns } from "./AlarmStatus.vue?vue&type=template&id=bc9b14ba"
import script from "./AlarmStatus.vue?vue&type=script&lang=js"
export * from "./AlarmStatus.vue?vue&type=script&lang=js"
import style0 from "./AlarmStatus.vue?vue&type=style&index=0&id=bc9b14ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports